export default __webpack_public_path__ + "static/media/icon_appointments_pressed.15b6a3af.svg";